<template>
    <div  class="wrap">
        <div class="login-page-box">
            <div class="container" style="height: 100%">
                <div class="row" style="height: 100%">
                    <div class="col" style="height: 100%">
                        <div class="text-center" style="height: 100%">
                            <div class="spinner-grow text-light" role="status" style="margin-top:300px;">
                                <span class="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
    methods: {
        async setLogin() {
            //await axios.get("/api/user/image/move/" + uid)

            // uid が無い / 数値でない（文字列 "undefined" 等）まま
            // "/api/user/auth/undefined" を叩かないようにする。
            // 判定は React 側（frontend/src/features/auth/hooks/useAuthLogin.ts）と揃える。
            const uid = Number(this.$route.query.uid)
            if (!Number.isInteger(uid) || uid <= 0) {
                // セッションベースで認証判定を行うログイン画面へ戻す
                window.location.href = "/auth"
                return
            }

            await axios.get("/api/user/auth/" + uid)
                .then(
                    (response) => {

                        if (response.data.first_type) {
                            localStorage.clear()
                            this.setFirst(uid)
                        }

                        if (response.data.is_change_login == false && response.data.is_entry == true ) {
                            window.location.href = "/auth/check"
                        }
                        else if (response.data.is_entry == false) {
                            window.location.href = "/signup/continue"
                        }
                        else {
                            // 休止中ユーザーは設定画面にリダイレクト
                            if (response.data.is_dormant) {
                                window.location.href = "/setting"
                            } else if (localStorage.getItem('redirect') !== null) {
                                let url = localStorage.getItem('redirect')
                                localStorage.clear()

                                window.location.href = url
                            } else {
                                window.location.href = "/search"
                            }
                        }
                    }
                )
                .catch((error) => {
                    this.$showErrorToast("ログインに失敗しました。");
                })
        },
        async setFirst(uid) {
            let response = await axios.get("/api/user/first/set/" + uid)
        }
    },
    mounted() {
        this.setLogin()
    },
};
</script>
    
<style scoped>

.login-page-box {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-color: #6b4eff;
}
</style>
